export default __webpack_public_path__ + "static/media/miscellaneous05.579ed47d.png";